import '@atlassian/soy-template-plugin-js/src/js/atlassian-deps.js';
import '@atlassian/soy-template-plugin-js/src/js/soyutils.js';

import '../soy/aui.soy';
import '../soy/avatar.soy';
import '../soy/badges.soy';
import '../soy/buttons.soy';
import '../soy/dialog2.soy';
import '../soy/dropdown.soy';
import '../soy/dropdown2.soy';
import '../soy/expander.soy';
import '../soy/form.soy';
import '../soy/group.soy';
import '../soy/icons.soy';
import '../soy/inline-dialog2.soy';
import '../soy/labels.soy';
import '../soy/lozenges.soy';
import '../soy/message.soy';
import '../soy/navigation.soy';
import '../soy/page.soy';
import '../soy/panel.soy';
import '../soy/progress-tracker.soy';
import '../soy/sidebar.soy';
import '../soy/table.soy';
import '../soy/tabs.soy';
import '../soy/toolbar.soy';
import '../soy/toolbar2.soy';
import '../soy/trigger.soy';

export default window.aui;



// WEBPACK FOOTER //
// src/entry/aui-soy.js